/*eslint radix: ["error", "as-needed"]*/

import moment from 'moment';

const weight = car => {
  let total = 0;
  return total;
};

const carMapper = car => {
  return {
    ...car
  };
};

const daysToM = car => {
  if (car.maintenances && car.maintenances.length > 0) {
    let { maintenances } = car;
    return maintenances.length > 0 ? Math.min(...maintenances.map(m => moment().diff(moment(m.virtualDate, 'YYYY-MM-DD'), 'days'))) : null;
  }
  return null;
};

const daysToFutureM = car => {
  if (car.maintenances && car.maintenances.length > 0) {
    let { maintenances } = car;
    // MEMO using Math.max since future daysToM value will range from 0 to negative
    return maintenances.length > 0 ? Math.max(...maintenances.filter(maintenance => moment(maintenance.virtualDate).isAfter(moment())).map(m => moment().diff(moment(m.virtualDate, 'YYYY-MM-DD'), 'days'))) : null;
  }
  return null;
};

const daysToMaintenanceLead = car => {
  if (car.leadMaintenances && car.leadMaintenances.length > 0) {
    let { leadMaintenances } = car;
    return leadMaintenances.length > 0 ? Math.min(...leadMaintenances.map(m => moment().diff(moment(m.virtualDate, 'YYYY-MM-DD'), 'days'))) : null;
  }
  return null;
};
const statusWeight = car => {
  let statusWeight = 0;
  const flags = { red: 1, orange: 2, green: 3 };
  if (car.shutdown === true) {
    if (car.status === 'disconnected') {
      statusWeight = flags.red;
    }
    if (car.status === 'connected') {
      statusWeight = flags.orange;
    }
  } else {
    if (car.status === 'disconnected') {
      statusWeight = flags.red;
    }
    if (car.status === 'shutdown') {
      statusWeight = flags.orange;
    }
    if (car.status === 'connected') {
      statusWeight = flags.green;
    }
  }
  return statusWeight;
};

const sortByWeight = (car1, car2) => car2.weight - car1.weight;

export default {
  weight,
  carMapper,
  sortByWeight,
  daysToM,
  daysToFutureM,
  daysToMaintenanceLead,
  statusWeight
};
